import type { MouseEvent } from 'react';

/** The id of the shell's `<main>`, the skip link's fallback target. */
export const MAIN_CONTENT_ID = 'main-content';

/**
 * The bypass block (WCAG 2.4.1, #205): the first stop in the tab order.
 *
 * On Mail it says "Skip to message list" and puts focus on the list itself
 * (the grid is the list's single tab stop, so j/k work straight away);
 * everywhere else "Skip to content", onto the shell's `<main>`. It is a real
 * link to `#main-content`, so it still does something with scripts slow to
 * start, and the click handler only makes the landing precise.
 */
export function SkipLink({ onMail }: { onMail: boolean }) {
  const skip = (event: MouseEvent<HTMLAnchorElement>) => {
    const list = onMail ? document.querySelector<HTMLElement>('[role="grid"][aria-label="Messages"]') : null;
    const target = list ?? document.getElementById(MAIN_CONTENT_ID);
    if (!target) return;
    event.preventDefault();
    target.focus();
    target.scrollIntoView?.({ block: 'nearest' });
  };
  return (
    <a className="skip-link" href={`#${MAIN_CONTENT_ID}`} onClick={skip}>
      {onMail ? 'Skip to message list' : 'Skip to content'}
    </a>
  );
}
